
import { UserCredentials } from "../../api/model";
import { GA_TRACKING_ID } from "../../constants";
import Cookies from "../../cookies";
import { exists } from "../object";

function parseClickIdentifier(cookieValue: string | undefined): string | undefined {
    if (!cookieValue || cookieValue === "") {
        return cookieValue;
    }

    return cookieValue.slice(cookieValue.lastIndexOf(".") + 1);
}

export default function getAdParameters(): UserCredentials["ad"] {
    const fbp = Cookies.get("_fbp");
    // _fbc cookie value has this format: version.subdomainIndex.creationTime.fbclid
    // https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
    const fbclid = parseClickIdentifier(Cookies.get("_fbc"));
    // _gac_ cookie value has this format: version.timestamp.gclid
    // https://support.google.com/analytics/answer/7519794
    const gclid = parseClickIdentifier(Cookies.get(`_gac_${GA_TRACKING_ID}`));

    const ad = {
        fbp,
        fbclid,
        gclid
    };

    if (Object.values(ad).filter(exists).length === 0) {
        return undefined;
    }

    return ad;
}
